export default "__VITE_ASSET__BqZib3pD__"